import { Link as RouterLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { projectsDb } from '../../lib/db/index.js';

interface Props {
  projectId: string;
}

/**
 * 投稿詳細ページで「このプロジェクトに紐付き」を表示するバッジ。
 *
 * - データ取得成功 → project 名を clickable link で表示
 * - 取得失敗 / 削除済 / 権限なし → 「(削除済プロジェクト)」フォールバック表示、クリック不可
 *
 * fetch 失敗の理由（Rules 拒否 / 物理削除 / 一時的ネットワーク）を区別せず一律フォールバックする。
 * 細かく見たいユーザは ProjectsPage を直接見る運用。
 */
export function ProjectBadge({ projectId }: Props) {
  const q = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => projectsDb.findById(projectId),
    staleTime: 60_000,
  });

  if (q.isPending) {
    return <span className="mono" style={{ color: 'var(--ink-4)', fontSize: 11 }}>…</span>;
  }
  if (!q.data) {
    return (
      <span className="orphan-project-badge mono">(削除済トピック)</span>
    );
  }
  return (
    <RouterLink
      to={`/projects/${q.data.id}`}
      className="project-badge-link"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        textDecoration: 'none',
        color: 'var(--ink)',
      }}
    >
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          background: q.data.color,
          borderRadius: 2,
          flexShrink: 0,
        }}
      />
      {q.data.name}
    </RouterLink>
  );
}
